import { from, Observable, of } from "rxjs";

export function outlookAsyncOf<T>(val: T) {
  return {
    ...val,
    getAsync: (callback: (arg: Office.AsyncResult<T>) => void) => {
      callback(<any>{
        value: val,
        status: Office.AsyncResultStatus.Succeeded,
      });
    },
  };
}

export function outlookAsyncFrom<T>(func: () => T) {
  const val = func();
  return outlookAsyncOf(val);
}

export function getAsync<T>(subject: {
  getAsync(callback?: (asyncResult: Office.AsyncResult<T>) => void): void;
}): Promise<T> {
  return new Promise((resolve, reject) => {
    subject.getAsync((result) => {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        const value = result.value;
        resolve(value);
      } else {
        reject(result.error);
      }
    });
  });
}

export function addAsync(value, subject: {
  addAsync(t, callback?: (asyncResult: Office.AsyncResult<void>) => void): void;
}): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    subject.addAsync(value, (result: Office.AsyncResult<void>) => {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        resolve(result.value);
      } else {
        reject(result.error);
      }
    })
  })
}

export function removeAsync(value, subject: {
  removeAsync(t, callback?: (asyncResult: Office.AsyncResult<void>) => void): void;
}): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    subject.removeAsync(value, (result: Office.AsyncResult<void>) => {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        resolve(result.value);
      } else {
        reject(result.error);
      }
    });
  });
}

export function setAsync(value, subject: {
  setAsync(t, callback?: (asyncResult: Office.AsyncResult<void>) => void): void;
}): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    subject.setAsync(value, (result: Office.AsyncResult<void>) => {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        resolve(result.value);
      } else {
        reject(result.error);
      }
    })
  })
}

export function observableOfOutlookAsync<T>(
  subject: { getAsync(callback: (asyncResult: Office.AsyncResult<T>) => void): void } | T
): Observable<T> {
  // Case 1: Office.js async API (object with getAsync)
  if (typeof (subject as any)?.getAsync === "function") {
    return from(
      new Promise<T>((resolve, reject) => {
        (subject as any).getAsync((result: Office.AsyncResult<T>) => {
          if (result.status === Office.AsyncResultStatus.Succeeded) {
            resolve(result.value);
          } else {
            reject(result.error);
          }
        });
      })
    );
  }

  // Case 2: Already a value → wrap in Observable
  return of(subject as T);
}
